import { render, staticRenderFns } from "./slider-item.vue?vue&type=template&id=46dcefeb&scoped=true&"
import script from "./slider-item.vue?vue&type=script&lang=js&"
export * from "./slider-item.vue?vue&type=script&lang=js&"
import style0 from "./slider-item.vue?vue&type=style&index=0&id=46dcefeb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dcefeb",
  null
  
)

export default component.exports